import React from "react";
import Template from "../../../../templates/Crew/Bunkering/ServerUpdate/ServerUpdateBunkeringComplete";
import Default from "../../../../layouts/DefaultCrew";

const ServerUpdateBunkeringComplete = (): React.ReactElement => {
  return (
    <Default title="" selectedTitle={"Bunkering"}>
      <Template />
    </Default>
  );
};

export default ServerUpdateBunkeringComplete;
